import { Component, OnInit, Input, OnDestroy, ViewChild, PLATFORM_ID, Inject } from '@angular/core';
import { NguCarousel, NguCarouselConfig, NguCarouselStore } from '@ngu/carousel';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import * as _ from 'underscore';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { MapOverviewStats, MapOverviewStatsComponent } from '../map-overview-stats/map-overview-stats.component';
import * as jQuery from 'jquery';
import { isPlatformBrowser } from '@angular/common';

@Component({
	selector: 'app-navigation-carousel',
	templateUrl: './navigation-carousel.component.html',
	styleUrls: ['./navigation-carousel.component.css']
})
export class NavigationCarouselComponent extends MapOverviewStatsComponent implements OnInit, OnDestroy {
	@ViewChild('carousel', { static: true }) carousel: NguCarousel<any>;
	@Input() widgetdata;
	@Input() uniqueoverwriteid: string;

	public key: string;
	public navWidgets = [];
	public carouselOne: NguCarouselConfig;
	public activeIndex = 0;
	public currentPath;
	private carouselToken: string;
	public hasData;
	public overviewStats: MapOverviewStats[] = [];
	public overviewStatsData: any;
	private navIndex = 0;
	private navItemsStatus = {};
	public deviceWidth;
	public version;

	constructor(
		protected analyticsDataModel: AnalyticsDataModel,
		protected analyticsService: AnalyticsService,
		@Inject(PLATFORM_ID) private platformId: Object
	) {
		super(analyticsService, analyticsDataModel);
		this.carouselOne = {
			grid: { xs: 2, sm: 2, md: 3, lg: 3, all: 0 },
			slide: 1,
			speed: 600,
			point: {
				visible: false
			},
			loop: false,
			touch: true
		};
		EmitterService.get(EVENT_EMITTERS.NAVIGATION_STATUS).subscribe((res) => {
			this.navItemsStatus[res.path] = res;
		});
		EmitterService.get(EVENT_EMITTERS.NAVIGATION_DONE).subscribe((response) => {
			setTimeout(() => {
				this.currentPath = this.analyticsDataModel.getCurrentPath();
				this.activeIndex = 0;
				this.navIndex = _.findIndex(this.navWidgets, (navItem) => {
					return navItem.widgetPath === this.currentPath;
				});
				this.scrollToSlide(this.navIndex);
				// this.navigateToPage(this.navWidgets[this.navIndex], this.navIndex);
			}, 100);
		});
		EmitterService.get(EVENT_EMITTERS.SET_ACTIVE_STATE_TO_CURRENT_SLIDE).subscribe((response) => {
			this.activeIndex = response.index;
		});
	}

	ngOnInit() {
		this.key = 'MARKETRON_OVERVIEW_STATS_BY_PRODUCT';
		this.version = this.analyticsDataModel.config.version.toLowerCase();
		super.ngOnInit();
		this.navWidgets = JSON.parse(decodeURI(this.widgetdata));
		this.navWidgets = this.sortArrayByType(this.navWidgets, 'displayOrder');
		for (const navWidget of this.navWidgets) {
			if (navWidget.widgetTitle === 'overview') {
				navWidget.widgets = this.analyticsDataModel.config.widgets;
			} else {
				for (const product of this.analyticsDataModel.config.products) {
					if (product.productURL === navWidget.widgetPath) {
						product.widgets = this.sortArrayByType(product.widgets, 'displayOrder');
						navWidget.widgets = product.widgets;
					}
				}
			}
			navWidget.downloadconfig = decodeURI(navWidget.downloadconfig);
		}
		this.currentPath = this.analyticsDataModel.getCurrentPath();
		this.navIndex = _.findIndex(this.navWidgets, (navItem) => {
			return navItem.widgetPath === this.currentPath;
		});
		this.navigateToPage(this.navWidgets[this.navIndex], this.navIndex);
	}

	requestData() {
		this.hasData = true;
		this.widgetDataSubscription = this.analyticsService
			.processOverviewRequest(this.key, null, this.uniqueoverwriteid)
			.subscribe((response: any) => {
				if (response.success) {
					this.hasData = true;
					this.processResponseData(response);
				} else {
					this.hasData = false;
					for (const product in this.overviewStatsData) {
						this.overviewStatsData[product]['clicks'] = 0;
						this.overviewStatsData[product]['impressions'] = 0;
						this.overviewStatsData[product]['ctr'] = 0;
						this.overviewStatsData[product]['completions'] = 0;
						this.overviewStatsData[product]['completions_rate'] = 0;
					}
				}
			});
	}

	mapResponseDataToInterface(responseData: any) {
		let count = 0;
		const overviewStatsObj = {};
		for (const responseObj of responseData) {
			if (count !== responseData.length - 1) {
				const key = this.getProductKeyByProductName(responseObj.product_name.replace(/\s/g, '').toLowerCase());
				overviewStatsObj[key] = {};
				overviewStatsObj[key]['productId'] = parseInt(responseObj.product_id);
				overviewStatsObj[key]['productName'] = responseObj.product_name;
				overviewStatsObj[key]['productSelected'] = true;
				overviewStatsObj[key]['impressions'] = responseObj.impressions != null ? parseInt(responseObj.impressions) : 0;
				overviewStatsObj[key]['clicks'] = responseObj.clicks != null ? parseInt(responseObj.clicks) : 0;
				overviewStatsObj[key]['audience'] = responseObj.audience != null ? parseInt(responseObj.audience) : 0;
				overviewStatsObj[key]['opens'] = responseObj.opens != null ? parseInt(responseObj.opens) : 0;
				overviewStatsObj[key]['hasClicks'] = !(overviewStatsObj[key]['productName'] === 'CTV');
				overviewStatsObj[key]['isEmail'] = !(overviewStatsObj[key]['productName'] === 'Email');
				overviewStatsObj[key]['ctr'] = responseObj.ctr != null ? parseFloat(responseObj.ctr) : 0;
				overviewStatsObj[key]['hasCtr'] = !(overviewStatsObj[key]['productName'] === 'CTV');
				overviewStatsObj[key]['completions'] =
					responseObj.completions != null ? parseFloat(responseObj.completions) : 0;
				overviewStatsObj[key]['completions_rate'] =
					responseObj.completions_rate != null ? parseFloat(responseObj.completions_rate) : 0;
				overviewStatsObj[key]['isExclude'] = count === responseData.length - 1;
				overviewStatsObj[key]['isDisabled'] =
					overviewStatsObj[key]['clicks'] === 0 && overviewStatsObj[key]['impressions'] === 0;
				count++;
				this.overviewStats.push(overviewStatsObj[key]);
			}
		}
		this.overviewStatsData = overviewStatsObj;
	}

	navigateToPage(nav, index) {
		this.scrollToSlide(index);
		let navStatus;
		for (const navItem in this.navItemsStatus) {
			if (navItem === nav.widgetPath) {
				navStatus = nav.isDisabled;
			}
		}
		if (
			!navStatus &&
			this.analyticsDataModel.selectedCampaigns.length > 0 &&
			this.analyticsDataModel.selectedAdvertisers.length > 0
		) {
			EmitterService.get(EVENT_EMITTERS.NAVIGATE).emit({ name: nav.widgetPath });
		}
	}

	initDataFn(key: NguCarouselStore) {
		this.carouselToken = key.token;
		this.scrollToSlide(this.navIndex);
	}

	// resetFn() {
	// 	this.carousel.reset(this.carouselToken);
	// }

	scrollToSlide(index) {
		if (index !== this.navWidgets.length - 1) {
			index = index > 0 ? index - 1 : 0;
		} else {
			index = this.navWidgets.length - 3;
		}
		this.carousel.moveTo(index);
	}

	navigateToWidget(index, widget) {
		setTimeout(() => {
			this.activeIndex = index;
			EmitterService.get(EVENT_EMITTERS.NAVIGATE_TO_SLIDE).emit({ index, widget });
		});
	}

	sortArrayByType(array, type): any[] {
		return _.sortBy(array, type);
	}

	ngOnDestroy() {
		super.ngOnDestroy();
	}
}
